import { NotificationData } from '@/common/types/notifications'
import { create } from 'zustand'

type State = {
  notifications: NotificationData[]
  notSeenCount: number
  lastDisplayIdentifier: string
  refreshTick: number
}

type Action = {
  setNotifications: (notifications: State['notifications']) => void
  setNotSeenCount: (count: State['notSeenCount']) => void
  setLastDisplayIdentifier: (newLastDisplayIdentifier: State['lastDisplayIdentifier']) => void
  incrementRefreshTick: () => void
}

export const useNotificationStore = create<State & Action>((set) => ({
  notifications: [],
  notSeenCount: 0,
  lastDisplayIdentifier: '',
  refreshTick: 0,

  setNotifications: (notifications) => set({ notifications }),
  setNotSeenCount: (count) => set({ notSeenCount: count }),
  setLastDisplayIdentifier: (newLastDisplayIdentifier) => set({ lastDisplayIdentifier: newLastDisplayIdentifier }),
  incrementRefreshTick: () => set((state) => ({ refreshTick: state.refreshTick + 1 })),
}))
